export default {
  setDebugMsg (state, msg) {
    state.debugMsg = msg
  },
  setLiveProduct (state, productData) {
    let productIndex = state.products.findIndex(item => item.productId === productData.productId)
    if (productIndex === -1) {
      state.products.push(productData)
    } else {
      state.products.splice(productIndex, 1, productData)
    }
  },
  setLiveProducts (state, products) {
    for (let product of products) {
      let productIndex = state.products.findIndex(item => item.productId === product.productId)
      if (productIndex === -1) {
        state.products.push(product)
      } else {
        state.products.splice(productIndex, 1, product)
      }
    }
  },
  setCartProducts (state, cartProducts) {
    state.cart.cartContents = cartProducts
  },
  setCartGifts (state, cartGifts) {
    state.cart.giftContents = cartGifts
  },
  setCartErrors (state, cartErrors) {
    state.cart.cartErrors = cartErrors
  },
  setSelectedProductCodeId (state, productCodeId) {
    state.selectedProductCodeId = productCodeId
  },
  setSelectedAttributeId (state, attributeId) {
    state.selectedAttributeId = attributeId
  },
  setAllAttributes (state, data) {
    state.allAttributes = data
  },
  setProductBadges (state, data) {
    state.productBadges = data
  },
  setConfig (state, data) {
    state.config = data
  },
  setOnlineStatus (state, data) {
    state.onlineStatus = data
  },
  openProductCardModal (state, productId) {
    state.productCardModal.productId = productId
    state.productCardModal.open = true
  },
  closeProductCardModal (state) {
    state.productCardModal.open = false
    state.productCardModal.productId = null
  }
}
